import {Component} from "@angular/core";
import {DxBaseModalComponent} from "../dx-base-modal.component";
import {SuiModal} from "ng2-semantic-ui";
import {DxModalResult} from "../../../domain/dx-modal-result";
import {DxModalContext} from "../../../domain/dx-modal-context";


@Component({
  selector: 'dx-confirm-modal',
  templateUrl: './dx-confirm-modal.component.html',
  styleUrls: ['./dx-confirm-modal.component.css']
})
export class DxConfirmModalComponent extends DxBaseModalComponent {
  constructor(protected _modal: SuiModal<DxModalContext, DxModalResult, DxModalResult>) {
    super(_modal);
    this.message = this._modal.context.message;
  }
}
